import BackgroundImage from "../../../components/ui/BackgroundImage";
import bgImage from "../assets/images/background.webp";
import FuelFiller from "./FuelFiller";
import GasStationHeading from "./GasStationHeading";
import GasStationMarket from "./GasStationMarket";

import { motion, AnimatePresence } from "framer-motion";

interface Props {
  className?: string;
}

const GasStation = ({ className = "" }: Props) => {
  return (
    <BackgroundImage
      imageSrc={bgImage}
      className={`overflow-hidden ${className}`}
    >
      <div className=" h-screen relative flex  justify-center items-center">
        {/** Top slideshow */}

        {/**  <Slideshow
          items={["ATLANTIS ROLEPLAY"]}
          className="bg-[#1A8BF7] h-8 flex items-center absolute top-0 left-0 w-full"
          itemClassName="text-[11px] tracking-[0.05em] text-white/80 uppercase font-medium"
          gapPx={40}
          speedPxPerSec={120}
          pauseOnHover
          direction="left"
          ariaLabel="Atlantis roleplay marquee"
        />
 */}
        {/** Main */}
        <AnimatePresence>
          <motion.div
            key="animated-box"
            initial={{ opacity: 0, y: 50 }} // start position (below)
            animate={{ opacity: 1, y: 0 }} // visible
            exit={{ opacity: 0, y: 50 }} // leave down
            transition={{ duration: 0.4, ease: "easeOut" }}
            className=""
          >
            <main className="p-3 w-full max-w-[660px] xl:max-w-[770px]">
              {/** Header */}
              <GasStationHeading
                titleWords={[
                  { word: "Benzinarie" },
                  { word: "Station", isHighlighted: true },
                ]}
                description="Show how you cool for everyone around you"
              />

              {/** Fill car */}
              <div className="my-3">
                <FuelFiller
                  capacityLiters={50}
                  pricePerLiter={1.009}
                  defaultValue={25}
                  currency="$"
                  onConfirmFill={(liters, price) =>
                    console.log({ liters, price })
                  }
                />
              </div>

              {/** Market */}

              <GasStationMarket />
            </main>
          </motion.div>
        </AnimatePresence>

        {/** Bottom slideshow */}
        {/**   <Slideshow
          items={["ATLANTIS ROLEPLAY"]}
          className="bg-[#1A8BF7] h-8 flex items-center absolute bottom-0 left-0 w-full"
          itemClassName="text-[11px] tracking-[0.05em] text-white/80 uppercase font-medium"
          gapPx={40}
          speedPxPerSec={120}
          pauseOnHover
          direction="left"
          ariaLabel="Atlantis roleplay marquee"
        /> */}
      </div>
    </BackgroundImage>
  );
};

export default GasStation;
